module.exports = __webpack_public_path__ + "static/media/供应链协同管理系统.4469a1dc.png";